module.exports = __webpack_public_path__ + "img/bout-ensemble.55daf823.png";